import { ErrorPageContent } from '@shared/components/error-page-content/error-page-content'

export const PageNotFound = () => (
  <ErrorPageContent
    title='Page not found'
    errorCode='404'
    message='The page you are trying to open does not exist. You may have mistyped the address, or  the page has been moved to another URL.'
  />
)
